"use strict";

// This scotch tapes an issue where SSR wont work with Drawers
var tsxSafeGlobal = global;
if (tsxSafeGlobal && tsxSafeGlobal.Element === undefined) {
  tsxSafeGlobal.Element = function () {};
}
